import { UpdateSchoolCustomCssDocument } from "@pathwright/graphql-client/src/generated"

export default UpdateSchoolCustomCssDocument
